// const baseUrl = 'http://localhost:8080/api'
const baseUrl = '/api';

export default baseUrl;